import React from "react";
import {makeStyles, Slide, Snackbar, SnackbarContent, IconButton} from "@material-ui/core";
import PropTypes from "prop-types";
import clsx from "clsx";
import {CustomButton, CloseIcon} from "@hapinest/theme";
import CustomSnackbarMessage from "./CustomSnackbarMessage";

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 3000,
        "& .MuiSnackbarContent-root": {
            flexWrap: "nowrap"
        }
    },
    content: {
        padding: theme.spacing(1, 0),
    },
    warningStyle: {
        background: theme.palette.error.danger + "!important",
    },
    warningStyle2: {
        background: "#F8D0D1 !important",
    },
    successStyle: {
        backgroundColor: theme.palette.primary["900"] + " !important",
    },
    successStyle2: {
        backgroundColor: theme.palette.primary["200"] + " !important",
    },
    infoStyle: {
        background: theme.palette.secondary["900"] + " !important",
    },
    buttonStyle: {
        background: theme.palette.grey["900"],
    },
    close: {
        marginRight: theme.spacing(1.5),
        "& i": {
            color: theme.palette.grey["0"]
        }
    },
}));

const CustomSnackbar = ({
    className,
    open,
    vertical,
    horizontal,
    withIcon,
    hideDuration,
    type,
    message,
    onClose,
    buttonText,
    onButtonClick,
    animationDirection,
    contentClassName,
    closeIcon
}) => {
    const classes = useStyles();

    return (
        <Snackbar
            className={clsx(classes.root, className)}
            anchorOrigin={{
                vertical: vertical,
                horizontal: horizontal,
            }}
            open={open}
            autoHideDuration={hideDuration}
            onClose={onClose}
            TransitionComponent={props => (
                <Slide
                    {...props}
                    direction={animationDirection || "up"}
                />
            )}
        >
            <SnackbarContent
                className={clsx(classes.content, contentClassName,
                    { [classes.warningStyle]: type === "warning" },
                    { [classes.warningStyle2]: type === "warning2" },
                    { [classes.infoStyle]: type === "info"},
                    { [classes.successStyle]: type === "success"},
                    { [classes.buttonStyle]: type === "button"},
                    { [classes.successStyle2]: type === "success2"},
                )}
                message={
                    <CustomSnackbarMessage
                        withIcon={withIcon}
                        type={type}
                        message={message}
                    />
                }
                action={
                    <>
                        {buttonText && (
                            <CustomButton
                                onClick={onButtonClick}
                            >
                                {buttonText}
                            </CustomButton>
                        )}
                        {closeIcon && (
                            <IconButton
                                aria-label="close"
                                className={clsx(classes.close)}
                                onClick={onClose}
                            >
                                <CloseIcon/>
                            </IconButton>
                        )}
                    </>
                }
            />
        </Snackbar>
    );
};


CustomSnackbar.defaultProps = {
    withIcon: false,
    hideDuration: 6000,
    vertical: "bottom",
    horizontal: "center"
};

CustomSnackbar.propTypes = {
    className: PropTypes.any,
    open: PropTypes.bool.isRequired,
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
    withIcon: PropTypes.bool,
    hideDuration: PropTypes.number,
    type: PropTypes.oneOf(["success", "success2", "info", "warning", "warning2", "button"]).isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]).isRequired,
    onClose: PropTypes.func,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
    animationDirection: PropTypes.oneOf(["up", "down"]),
    contentClassName: PropTypes.any,
    closeIcon: PropTypes.bool
};

export default CustomSnackbar;
